// NewsService.ts
import axios from 'axios';
import { axiosRequest } from '../AxiosService';
import { NewsResponse} from '../../type/response/NewsResponse';  
import { NewsType} from '../../pages/HomePage/Components/News/NewsLists';
import dayjs from 'dayjs';


/**
 * お知らせ一覧データを取得し、新着フラグを付与して返す
 * - 公開日から7日以内のものを「新着」とする
 * @returns お知らせ一覧データ、取得失敗時は空配列
 */
export const getNews = async (): Promise<NewsType[]> => {
   try {
   
    const response= await axiosRequest<NewsResponse[]>(
      "/news",
      "GET"
    );
   
      let NewsList: NewsType[] = [];
      response.forEach((value) => {
        let NewsData: NewsType = {
        id: value.id,              
        title:value.title,         
        category:value.category,
        contents: value.contents,     
        // publishedAt: dayjs(value.publishedAt).format('YYYY/MM/DD HH:mm'), 
         publishedAt: value.publishedAt,
        isNew: dayjs().diff(dayjs(value.publishedAt), 'day') <= 7  
        };
        NewsList.push(NewsData);
      });
      return NewsList;
    
} catch (error) {
  console.error("お知らせデータの取得に失敗しました:", error);
  return [];
   }
 };
